import { useId } from "react";

export const CodeBlock = ({ code }) => {
  const codeBlockId = `code-block-${useId().replace(/:/g, "")}`;

  return (
    <div>
      <div className="company-green-box rounded-top" style={{ textAlign: "right" }}>
        <button className="copy rounded" data-clipboard-target={`#${codeBlockId}`}>
          Copy To Clipboard
        </button>
      </div>
      <div className="dark-box rounded-bottom" style={{ position: "relative" }}>
        <pre id={codeBlockId}>{code}</pre>
      </div>
    </div>
  );
};
